import RegisterComponent from '../components/Register';

export default function Register() {
  return <RegisterComponent />;
}






